import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { KWhKmToMilesPipe } from '../pipes/k-wh-km-to-miles.pipe';
import { KmToMilesPipe } from '../pipes/km-to-miles.pipe';
import { WhToMWhPipe } from '../pipes/wh-to-mwh.pipe';
import { RemoveDecimalPointsPipe } from '../pipes/remove-decimal-points.pipe';
import { WhToKwhPipe } from '../pipes/wh-to-kwh.pipe';
import { HourToMinutePipe } from '../pipes/hour-to-minute.pipe';
import{ TransformXAxisPipe } from '../pipes/transform-xaxis.pipe';
import { CelsiusToFahrenheitPipe } from '../pipes/celsius-to-fahrenheit.pipe';
import { InTimePipe } from '../pipes/in-time.pipe';
import { RangeYPipe } from '../pipes/range-y.pipe';

@NgModule({
  declarations: [
    KWhKmToMilesPipe,
    CelsiusToFahrenheitPipe,
    KmToMilesPipe,
    WhToMWhPipe,
    RemoveDecimalPointsPipe,
    WhToKwhPipe,
    HourToMinutePipe,
    TransformXAxisPipe,
    InTimePipe,
    RangeYPipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    KWhKmToMilesPipe,
    CelsiusToFahrenheitPipe,
    KmToMilesPipe,
    WhToMWhPipe,
    RemoveDecimalPointsPipe,
    WhToKwhPipe,
    HourToMinutePipe,
    TransformXAxisPipe,
    InTimePipe,
    RangeYPipe
  ]
})
export class SharedPipesModule { }
